<template>
  <v-row>
    <v-col cols="12" md="11">
      <v-row align="baseline">
        <v-col cols="6" md="2">
          <v-menu
            ref="menuFromDateEntered"
            v-model="menuFromDateEntered"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                :value="fromDateEntered | dateFormat"
                :label="$t('ITEM.FROM_DATE_ENTERED')"
                append-icon="mdi-calendar"
                clearable
                readonly
                role="button"
                autocomplete="nope"
                @click:clear="fromDateEntered = null"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              ref="picker"
              v-model="fromDateEntered"
              min="1940-01-01"
              first-day-of-week="1"
              @change="saveFromDateEntered"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="6" md="3">
          <v-autocomplete
            v-model="currFilters.title"
            :label="$t('BOOKING.RESOURCES.ITEM')"
            :search-input.sync="title"
            :items="titles"
            :loading="loading"
            item-text="name"
            item-value="name"
            :no-data-text="$t('MESSAGE.NO_DATA_FILTER_TEXT')"
            clearable
          />
        </v-col>
        <v-col cols="6" md="3">
          <v-autocomplete
            v-model="currFilters.building_complex"
            :label="$t('BUILDING_COMPLEXES.ITEMS')"
            :search-input.sync="building_complex"
            :items="building_complexes"
            :loading="loading"
            item-text="name"
            item-value="id"
            :no-data-text="$t('MESSAGE.NO_DATA_FILTER_TEXT')"
            clearable
            multiple
            chips
            small-chips
            deletable-chips
            v-on="{
              change: [() => (building_complex = ''), getDataBuildings]
            }"
          />
        </v-col>
        <v-col cols="6" md="2">
          <v-menu
            ref="menuDateFrom"
            v-model="menuDateFrom"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                :value="dateFrom | dateFormat"
                :label="$t('ITEM.DATE_FROM')"
                append-icon="mdi-calendar"
                clearable
                readonly
                role="button"
                autocomplete="nope"
                @click:clear="dateFrom = null"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              ref="picker"
              v-model="dateFrom"
              min="1940-01-01"
              first-day-of-week="1"
              @change="saveDateFrom"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="6" md="2">
          <v-select
            v-model="currFilters.status"
            :items="statuses"
            item-text="name"
            item-value="id"
            :label="$t('ITEM.STATUS')"
            :loading="loading"
            chips
            small-chips
            multiple
            clearable
          >
            <template v-slot:selection="data">
              <v-chip
                text-color="white"
                v-bind="data.attrs"
                :input-value="data.selected"
                :color="data.item.color"
                close
                @click="data.select"
                @click:close="remove(data.item, currFilters.status)"
              >
                {{ data.item.name }}
              </v-chip>
            </template>
          </v-select>
        </v-col>
      </v-row>
      <v-row align="baseline">
        <v-col cols="6" md="2">
          <v-menu
            ref="menuToDateEntered"
            v-model="menuToDateEntered"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                :value="toDateEntered | dateFormat"
                :label="$t('ITEM.TO_DATE_ENTERED')"
                append-icon="mdi-calendar"
                clearable
                readonly
                role="button"
                autocomplete="nope"
                @click:clear="toDateEntered = null"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              ref="picker"
              v-model="toDateEntered"
              :min="fromDateEntered || '1940-01-01'"
              first-day-of-week="1"
              @change="saveToDateEntered"
            ></v-date-picker>
          </v-menu>
        </v-col>

        <v-col cols="6" md="3">
          <v-autocomplete
            v-model="currFilters.customer"
            :label="$t('BOOKING.RESERVATIONS.CUSTOMER')"
            :search-input.sync="customer"
            :items="customers"
            :loading="loading"
            item-text="name"
            item-value="name"
            :no-data-text="$t('MESSAGE.NO_DATA_FILTER_TEXT')"
            clearable
          />
        </v-col>

        <v-col cols="6" md="3">
          <v-autocomplete
            v-model="currFilters.building"
            :label="$t('BUILDINGS.ITEMS')"
            :items="buildings"
            :loading="loading"
            :search-input.sync="building"
            item-text="street"
            item-value="id"
            :no-data-text="$t('MESSAGE.NO_DATA_FILTER_TEXT')"
            clearable
            multiple
            chips
            small-chips
            deletable-chips
            @change="building = ''"
          />
        </v-col>

        <v-col cols="6" md="2">
          <v-menu
            ref="menuDateTo"
            v-model="menuDateTo"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                :value="dateTo | dateFormat"
                :label="$t('ITEM.DATE_TO')"
                append-icon="mdi-calendar"
                clearable
                readonly
                role="button"
                autocomplete="nope"
                @click:clear="dateTo = null"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              ref="picker"
              v-model="dateTo"
              :min="dateFrom || '1940-01-01'"
              first-day-of-week="1"
              @change="saveDateTo"
            ></v-date-picker>
          </v-menu>
        </v-col>
      </v-row>
    </v-col>
    <v-col
      cols="12"
      md="1"
      align-self="center"
      class="d-flex flex-wrap justify-md-space-between"
    >
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-btn
            class="mb-1 mr-1"
            color="grey"
            depressed
            outlined
            @click="reset"
            v-on="on"
          >
            <v-icon>mdi-filter-remove</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('BUTTON.CLEAR_FILTER') }}</span>
      </v-tooltip>
      <v-btn class="mb-1" color="primary" depressed @click.prevent="setFilters">
        {{ $t('BUTTON.FIND') }}
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { dateFormat } from '@/modules/_global/filters';
import { debounce, cloneDeep, isEmpty } from 'lodash';
import { mapCacheActions } from 'vuex-cache';
import i18nRefreshData from '@/modules/_global/mixins/i18nRefreshData';
import listFilters from '@/modules/_global/mixins/list-filters';

export default {
  name: 'BookingReservationsListFilter',

  filters: {
    dateFormat
  },

  mixins: [i18nRefreshData, listFilters],

  data: () => ({
    options: {},

    delay: 0,
    expensiveFunc: null,

    statuses: [],

    title: null,
    titles: [],

    customer: null,
    customers: [],

    building_complex: null,
    building_complexes: [],

    building: null,
    buildings: [],

    menuFromDateEntered: false,
    fromDateEntered: null,

    menuToDateEntered: false,
    toDateEntered: null,

    menuDateFrom: false,
    dateFrom: null,

    menuDateTo: false,
    dateTo: null
  }),

  computed: {
    ...mapState(['loading']),
    ...mapState('booking_reservations', ['filters']),
    debouncedRequest() {
      return debounce(this.expensiveFunc, this.delay);
    }
  },

  watch: {
    title(val) {
      if (val !== this.currFilters.title && !isEmpty(val)) {
        this.expensiveFunc = this.getDataResources;
        this.debouncedRequest();
      }
    },
    building_complex(val) {
      if (val !== this.currFilters.building_complex && !isEmpty(val)) {
        this.expensiveFunc = this.getDataBuildingComplexes;
        this.debouncedRequest();
      }
    },
    customer(val) {
      if (val !== this.currFilters.customer && !isEmpty(val)) {
        this.expensiveFunc = this.getDataCustomers;
        this.debouncedRequest();
      }
    },

    fromDateEntered(val) {
      if (val) {
        this.currFilters = { ...this.currFilters, date_entered_from: val };
      } else {
        this.currFilters.date_entered_from = null;
      }
    },

    toDateEntered(val) {
      if (val) {
        this.currFilters = { ...this.currFilters, date_entered_to: val };
      } else {
        this.currFilters.date_entered_to = null;
      }
    },

    dateFrom(val) {
      if (val) {
        this.currFilters = { ...this.currFilters, date_from: val };
      } else {
        this.currFilters.date_from = null;
      }
    },

    dateTo(val) {
      if (val) {
        this.currFilters = { ...this.currFilters, date_to: val };
      } else {
        this.currFilters.date_to = null;
      }
    }
  },

  created() {
    if (!isEmpty(this.filters)) {
      this.currFilters = cloneDeep(this.filters);
      this.title = this.filters.title;
      this.customer = this.filters.customer;
      this.fromDateEntered = this.currFilters.date_entered_from;
      this.toDateEntered = this.currFilters.date_entered_to;
      this.dateFrom = this.currFilters.date_from;
      this.dateTo = this.currFilters.date_to;
      this.getDataBuildingComplexes();
      this.getDataBuildings();
      this.getDataResources();
      this.getDataCustomers();
    }
    this.refreshData();
    this.setFilters();
    this.setDelay(500);
  },

  methods: {
    ...mapActions('booking_reservations', [
      'getFilteredBuildingComplexes',
      'getFilteredBuildings',
      'getFilteredResources',
      'getFilteredCustomers'
    ]),
    ...mapCacheActions('booking_reservations', [
      'getBookingReservationsStatuses'
    ]),

    saveDateFrom(date) {
      this.$refs.menuDateFrom.save(date);
    },

    saveDateTo(date) {
      this.$refs.menuDateTo.save(date);
    },

    saveFromDateEntered(date) {
      this.$refs.menuFromDateEntered.save(date);
    },

    saveToDateEntered(date) {
      this.$refs.menuToDateEntered.save(date);
    },

    setDelay(v) {
      this.delay = v;
    },

    refreshData() {
      this.getBookingReservationsStatuses()
        .then(({ data }) => {
          this.statuses = data.data;
        })
        .catch(error => {
          this.error = error;
        });
    },

    getDataBuildingComplexes() {
      this.getFilteredBuildingComplexes({ search: this.building_complex })
        .then(({ data }) => {
          this.building_complexes = data.data;
        })
        .catch(error => {
          this.error = error;
        });
    },

    getDataBuildings() {
      this.getFilteredBuildings({
        building_complex: this.currFilters.building_complex
      })
        .then(({ data }) => {
          this.buildings = data.data;
        })
        .catch(error => {
          this.error = error;
        });
    },

    getDataResources() {
      this.getFilteredResources({ search: this.title })
        .then(({ data }) => {
          this.titles = data.data;
        })
        .catch(error => {
          this.error = error;
        });
    },

    getDataCustomers() {
      this.getFilteredCustomers({ search: this.customer })
        .then(({ data }) => {
          this.customers = data.data;
        })
        .catch(error => {
          this.error = error;
        });
    },

    remove(item, obj) {
      const index = obj.indexOf(item.id);
      if (index >= 0) obj.splice(index, 1);
    },

    reset() {
      this.title = null;

      this.customer = null;

      this.building_complex = null;

      this.building = null;
      this.buildings = [];

      this.menuFromDateEntered = false;
      this.fromDateEntered = null;

      this.menuToDateEntered = false;
      this.toDateEntered = null;

      this.menuDateFrom = false;
      this.dateFrom = null;

      this.menuDateTo = false;
      this.dateTo = null;

      this.currFilters = {};
      this.expensiveFunc = null;

      this.refreshData();
      this.setFilters();
    }
  }
};
</script>

<style lang="scss" scoped>
.row {
  > .col,
  > [class*='col-'] {
    padding-top: 4px;
    padding-bottom: 4px;
  }
}
</style>
